module.exports = __webpack_public_path__ + "img/jonathan.390fd4c6.jpg";